import AbandonoSurveyConfig from './tecnolite-abandono-carrito.json';
import ComprasSurveyConfig from './tecnolite-compras-realizadas.json';
import ExperienciaSurveyConfig from './tecnolite-experiencia-digital.json';
import B2BExperienciaDigital from './tecnolite-b2b-experiencia digital.json';
import B2BExperienciaCompra from './tecnolite-b2b-experiencia compra.json';
import vvcxSurveyConfig from './vcx-aerolinea.json';
import vvcxV2SurveyConfig from './new-vcx-aerolinea.json';
import cxAirlinev2 from './cx-new-aerolinea.json';
import cxAirline from './cx-aerolinea.json'
import cxShop from './cx-tienda.json'
import cxRestroom from './cx-sanitarios.json'
import cxConference from './cx-oficinas.json'
import { SupportedLanguages } from '../utils/common-types';
import { SurveyConfig } from '../services/response';

interface Param {
  key: string;
  value: any;
}

interface RegisteredSurvey {
  id: string;
  label: string;
  config: SurveyConfig;
  params?: Array<Param>;
}

const defaultDataTecnolite = {
  purchaseDateDisplay: {
    default: 'May 01, 2023',
    es: '01 de mayo de 2023'
  }
}

const defaultDataViva = {
  departureStationDisplay: {
    default: 'Monterrey',
    es: 'Monterrey'
  },
  arrivalStationDisplay: {
    default: 'Mexico City',
    es: 'Ciudad de México'
  },
  actualDepartureDisplay: {
    default: 'July 22, 2023',
    es: '22 de Julio de 2023.'
  },
  checkedBaggage: '1'
}

const defaultComplete = {
  title: {
    default: 'Thank you!',
    es: '¡Gracias!'
  },
  message: {
    default: '<p>We got your opinion.</p><p>All the team will work to give you a better experience.</p>',
    es: '<p>Hemos recibido tu opinión.</p><p>Todo el equipo trabajará para mejorar tu experiencia.</p>'
  },
}

const defaultPrivacyLinksTecnolite = {
  default: "https://tecnolite.mx/aviso-de-privacidad",
  es: "https://tecnolite.mx/aviso-de-privacidad",
}

const defaultPrivacyLinksViva = {
  default: "https://www.vivaaerobus.com/en-us/legal/privacy-notice",
  es: "https://www.vivaaerobus.com/es-mx/legal/aviso-de-privacidad",
}

const defaultPrivacyLinksCx = {
  default: "https://cx-mate.com/politica-de-privacidad.html",
  es: "https://cx-mate.com/politica-de-privacidad.html",
}


const defaultDataRestrooms = {
  country: "MX",
  building: "Reforma26",
  level: "3",
  space_type: "restroom",
  space: "womens restroom"
}

/*const defaultParams = [
  {
     key: 'SHOPPING_EXPERIENCE_CSAT',
     value: '1'
  }
]*/

export const registeredSurveysTecnolite: Array<RegisteredSurvey> = [
  {
    id: 'tec-cr',
    label: 'Tecnolite - Experiencia de compra',
    config: {
      surveyDef: Object.assign({ _id: 'tec-cr' }, ComprasSurveyConfig),
      data: defaultDataTecnolite,
      preferredLanguage: SupportedLanguages.es,
      complete: defaultComplete,
      privacyPolicy: defaultPrivacyLinksTecnolite,
      ruleCompleteMessage: "if (ctx.hasOwnProperty('SHOPPING_EXPERIENCE_NPS')){ return [0,1,2,3,4,5,6,7,8].includes(ctx['SHOPPING_EXPERIENCE_NPS']) ? {message: { es: '<p>Hemos recibido tu opinión.</p><p>Estamos trabajando para mejorar tu experiencia en nuestro sitio web.</p><p>¡Esperamos verte pronto en nuestra tienda en línea!</p>',default:'<p>We have received your opinion.</p><p>We are working to improve your experience on our website.</p><p>We hope to see you soon in our online store !</p>'}} : { message: { es: '<p>Hemos recibido tu opinión.</p><p>Estamos aquí para brindarte el mejor servicio.</p><p>¡Esperamos verte pronto en nuestra tienda en línea!</p>', default:'<p>We have received your opinion.</p><p>We are here to provide you with the best service.</p><p>We hope to see you soon in our online store!</ p>'}} }",
      extensions:{
        pages: [
          {
            type: "skippable",
            names: [
              "P5_TEC_EC"
            ],
            buttonName: {
              es: "Omitir",
              default: "Skip"
            },
            buttonNameLast: {
              es: "Omitir y terminar",
              default: "Skip and complete"
            },
            completeName: {
              es: "Enviar",
              default: "Send"
            },
            defaultCompleteName: {
              es: "Terminar",
              default: "Complete"
            }
          }
        ]
      }
    },
    params: []
  },
  {
    id: 'tec-ac',
    label: 'Tecnolite - Abandono de carrito',
    config: {
      surveyDef: Object.assign({ _id: 'tec-ac' }, AbandonoSurveyConfig),
      data: defaultDataTecnolite,
      preferredLanguage: SupportedLanguages.es,
      complete: defaultComplete,
      privacyPolicy: defaultPrivacyLinksTecnolite,
      ruleCompleteMessage: "if (ctx.hasOwnProperty('ABANDONMENT_REASONS')){ if(['1','2','4','other'].includes(ctx['ABANDONMENT_REASONS'])){ if(ctx.hasOwnProperty('CONCERN') || ctx.hasOwnProperty('PRODUCT')){ return { message: { es: '<p>En breve daremos seguimiento a tu inquietud.</p>',default:'<p>We will follow up on your concern shortly.</p>'}}} if(ctx.hasOwnProperty('COMMENT')){ return { message:{ es: '<p>Hemos recibido tu opinión.</p><p>Estamos aquí para brindarte el mejor servicio.¡Esperamos verte pronto en nuestra tienda en línea!</p><p>En breve daremos seguimiento a tu caso.</p>', default:'<p>We have received your opinion.</p><p>We are here to provide you with the best service. We hope to see you soon in our online store!</p><p>We will follow up on your case shortly.</ p>' }}} return {message: {es: '<p>Hemos recibido tu opinión.</p><p>Estamos trabajando para mejorar tu experiencia en nuestro sitio web.</p><p>¡Esperamos verte pronto en nuestra tienda en línea!</p>', default:'<p>We have received your opinion.</p><p>We are working to improve your experience on our website.</p><p>We hope to see you soon in our online store!</p>'}}}  else if (['3','5'].includes(ctx['ABANDONMENT_REASONS'])) { return { message: { es: '<p>Hemos recibido tu opinión.</p><p>¡Esperamos verte pronto en nuestra tienda en línea!</p>', default:'<p>We have received your opinion.</p><p>We hope to see you soon in our online store!</p>'}}}}",
      extensions:{
        pages: [
          {
            type: "skippable",
            names: [
              "P3_TEC_AC",
              "P5_TEC_AC",
              "P6_TEC_AC"
            ],
            buttonName: {
              es: "Omitir",
              default: "Skip"
            },
            buttonNameLast: {
              es: "Omitir y terminar",
              default: "Skip and complete"
            },
            completeName: {
              es: "Enviar",
              default: "Send"
            },
            defaultCompleteName: {
              es: "Terminar",
              default: "Complete"
            }
          }
        ]
      }
    },
    params: [
      {
        key: "fullName",
        value: "Name Test"
      }
    ]
  },
  {
    id: 'tec-ed',
    label: 'Tecnolite - Experiencia Digital en ecommerce',
    config: {
      surveyDef: Object.assign({ _id: 'tec-ed' }, ExperienciaSurveyConfig),
      data: defaultDataTecnolite,
      preferredLanguage: SupportedLanguages.es,
      complete: defaultComplete,
      privacyPolicy: defaultPrivacyLinksTecnolite,
      ruleCompleteMessage: "if (ctx.hasOwnProperty('REASON_VISIT')) { if(ctx['REASON_VISIT'] === '1'){ if(ctx.hasOwnProperty('GOAL_ACHIEVED') && ctx['GOAL_ACHIEVED'] === '1'){ if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '1'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>En nuestra tienda en línea, te esperan un mundo de productos nuevos y emocionantes descuentos.</p><p> ¡Esperamos verte pronto en nuestra tienda en línea!</p><p>En breve daremos seguimiento a tu caso.</p>',default:'<p>We have received your opinion.</p><p>A world of new products and exciting discounts await you in our online store.</p><p> We hope to see you soon in our online store!</p><p>We will follow up on your case shortly.</p>'} } } if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '2'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>En nuestra tienda en línea, te esperan un mundo de productos nuevos y emocionantes descuentos.</p><p> ¡Esperamos verte pronto en nuestra tienda en línea!</p>',default:'<p>We have received your opinion.</p><p>A world of new products and exciting discounts await you in our online store.</p><p> We hope to see you soon in our online store!</p>'} } } } if(ctx.hasOwnProperty('GOAL_ACHIEVED') && ctx['GOAL_ACHIEVED'] === '2'){ if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '1'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Lamentamos mucho que no hayas encontrado lo que buscabas en ese momento.</p><p>Estamos trabajando para mejorar tu experiencia en nuestro sitio web.</p><p>En breve daremos seguimiento a tu caso.</p>',default:'<p>We have received your opinion.</p><p>We are very sorry that you did not find what you were looking for at that moment.</p><p>We are working to improve your experience on our website.</p><p>We will follow up on your case shortly.</p>'} } } if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '2'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Lamentamos mucho que no hayas encontrado lo que buscabas en ese momento.</p><p>Estamos trabajando para mejorar tu experiencia en nuestro sitio web.</p>',default:'<p>We have received your opinion.</p><p>We are very sorry that you did not find what you were looking for at that moment.</p><p>We are working to improve your experience on our website.</p>'} } } } } else if (ctx['REASON_VISIT'] === '5') { if(ctx.hasOwnProperty('GOAL_ACHIEVED') && ctx['GOAL_ACHIEVED'] === '1'){ if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '1'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Estamos aquí para brindarte el mejor servicio.¡Esperamos verte pronto en nuestra tienda en línea!</p><p>En breve daremos seguimiento a tu caso.</p>',default:'<p>We have received your opinion.</p><p>We are here to provide you with the best service. We hope to see you soon in our online store!</p><p>We will follow up on your case shortly.</p>'} } } if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '2'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Estamos aquí para brindarte el mejor servicio.¡Esperamos verte pronto en nuestra tienda en línea!</p>',default:'<p>We have received your opinion.</p><p>We are here to provide you with the best service. We hope to see you soon in our online store!</p>'} } } } if(ctx.hasOwnProperty('GOAL_ACHIEVED') && ctx['GOAL_ACHIEVED'] === '2'){ if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '1'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Estamos trabajando para mejorar tu experiencia en nuestro sitio web.</p><p>¡Esperamos verte pronto en nuestra tienda en línea!</p><p>En breve daremos seguimiento a tu caso.</p>',default:'<p>We have received your feedback.</p><p>We are working to improve your experience on our website.</p><p>We hope to see you soon in our online store!</p><p> We will follow up on your case shortly.</p>'} } } if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '2'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Estamos trabajando para mejorar tu experiencia en nuestro sitio web.</p><p>¡Esperamos verte pronto en nuestra tienda en línea!</p>',default:'<p>We have received your feedback.</p><p>We are working to improve your experience on our website.</p><p>We hope to see you soon in our online store!</p>'} } } } } else if (ctx['REASON_VISIT'] === '2') { if(ctx.hasOwnProperty('GOAL_ACHIEVED')){ if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '1'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Estamos aquí para brindarte el mejor servicio.¡Esperamos verte pronto en nuestra tienda en línea!</p><p>En breve daremos seguimiento a tu caso.</p>',default:'<p>We have received your opinion.</p><p>We are here to provide you with the best service. We hope to see you soon in our online store!</p><p>We will follow up on your case shortly.</p>'} } } if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '2'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Estamos aquí para brindarte el mejor servicio.¡Esperamos verte pronto en nuestra tienda en línea!</p>',default:'<p>We have received your opinion.</p><p>We are here to provide you with the best service. We hope to see you soon in our online store!</p>'} } } } } else if (ctx['REASON_VISIT'] === '3') { if(ctx.hasOwnProperty('GOAL_ACHIEVED') && ctx['GOAL_ACHIEVED'] === '1'){ if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '1'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Estamos aquí para brindarte el mejor servicio.¡Esperamos verte pronto en nuestra tienda en línea!</p><p>En breve daremos seguimiento a tu caso.</p>',default:'<p>We have received your opinion.</p><p>We are here to provide you with the best service. We hope to see you soon in our online store!</p><p>We will follow up on your case shortly.</p>'} } } if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '2'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Estamos aquí para brindarte el mejor servicio.¡Esperamos verte pronto en nuestra tienda en línea!</p>',default:'<p>We have received your opinion.</p><p>We are here to provide you with the best service. We hope to see you soon in our online store!</p>'} } } } if(ctx.hasOwnProperty('GOAL_ACHIEVED') && ctx['GOAL_ACHIEVED'] === '2'){ if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '1'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Lamentamos los inconvenientes que puedas haber experimentado al intenart realizar una compra.</p><p>Estamos trabajando para mejorar tu experiencia en nuestro sitio web.</p><p>En breve daremos seguimiento a tu caso.</p>',default:'<p>We have received your feedback.</p><p>We are sorry for any inconvenience you may have experienced when trying to make a purchase.</p><p>We are working to improve your experience on our website.</p> <p>We will follow up on your case shortly.</p>'} } } if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '2'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Lamentamos los inconvenientes que puedas haber experimentado al intenart realizar una compra.</p><p>Estamos trabajando para mejorar tu experiencia en nuestro sitio web.</p>',default:'<p>We have received your feedback.</p><p>We are sorry for any inconvenience you may have experienced when trying to make a purchase.</p><p>We are working to improve your experience on our website.</p>'} } } } } else if (ctx['REASON_VISIT'] === '4') { if(ctx.hasOwnProperty('GOAL_ACHIEVED') && ctx['GOAL_ACHIEVED'] === '1'){ if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '1'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Estamos aquí para brindarte el mejor servicio.¡Esperamos verte pronto en nuestra tienda en línea!</p><p>En breve daremos seguimiento a tu caso.</p>',default:'<p>We have received your opinion.</p><p>We are here to provide you with the best service. We hope to see you soon in our online store!</p><p>We will follow up on your case shortly.</p>'} } } if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '2'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Estamos aquí para brindarte el mejor servicio.¡Esperamos verte pronto en nuestra tienda en línea!</p>',default:'<p>We have received your opinion.</p><p>We are here to provide you with the best service. We hope to see you soon in our online store!</p>'} } } } if(ctx.hasOwnProperty('GOAL_ACHIEVED') && ctx['GOAL_ACHIEVED'] === '2'){ if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '1'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Comprendemos lo importante que es para ti dar seguimiento a tus productos, estamos trabajando para mejorar tu experiencia.</p><p>En breve daremos seguimiento a tu caso.</p>',default:'<p>We have received your opinion.</p><p>We understand how important it is for you to follow up on your products, we are working to improve your experience.</p><p>We will follow up on your case shortly.</p>'} } } if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '2'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Comprendemos lo importante que es para ti dar seguimiento a tus productos, estamos trabajando para mejorar tu experiencia.</p>',default:'<p>We have received your opinion.</p><p>We understand how important it is for you to follow up on your products, we are working to improve your experience.</p>'} } } } } else if (ctx['REASON_VISIT'] === '6') { if(ctx.hasOwnProperty('GOAL_ACHIEVED') && ctx['GOAL_ACHIEVED'] === '1'){ if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '1'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Nos emociona que estes interesado en ser un distribuidor.</p><p>Estamos aquí para brindarte el mejor servicio.</p><p>En breve daremos seguimiento a tu caso.</p>',default:'<p>We have received your opinion.</p><p>We are excited that you are interested in being a distributor.</p><p>We are here to provide you with the best service.</p><p>We will shortly give you follow up on your case.</p>'} } } if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '2'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Nos emociona que estes interesado en ser un distribuidor.</p><p>Estamos aquí para brindarte el mejor servicio.</p>',default:'<p>We have received your opinion.</p><p>We are excited that you are interested in being a distributor.</p><p>We are here to provide you with the best service.</p>'} } } } if(ctx.hasOwnProperty('GOAL_ACHIEVED') && ctx['GOAL_ACHIEVED'] === '2'){ if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '1'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Lamentamos que no hayas podido proceder con la solicitud de ser distribuidor.</p><p>En breve daremos seguimiento a tu caso.</p>',default:'<p>We have received your opinion.</p><p>We regret that you have not been able to proceed with the request to be a distributor.</p><p>We will follow up on your case shortly.</p>'} } } if(ctx.hasOwnProperty('FOLLOW_UP') && ctx['FOLLOW_UP'] === '2'){ return { message: { es: '<p>Hemos recibido tu opinión.</p><p>Lamentamos que no hayas podido proceder con la solicitud de ser distribuidor.</p><p>Estamos trabajando para mejorar tu experiencia en nuestro sitio web.</p>',default:'<p>We have received your feedback.</p><p>We regret that you were unable to proceed with your distributor application.</p><p>We are working to improve your experience on our website.</p>'} } } } } }",
    },
    params: []
  },
  {
    id: 'tec-b2b-ed',
    label: 'B2B - Retroalimentación de experiencia digital en ecommerce',
    config: {
      surveyDef: Object.assign({ _id: 'tec-b2b-ed' }, B2BExperienciaDigital),
      data: defaultDataTecnolite,
      preferredLanguage: SupportedLanguages.es,
      complete: {
        title: {
          default: "We have received your opinion.",
          es: "Hemos recibido tu opinión."
        },
        message: {
          default: "<p>Your feedback helps us improve to offer you the best experience in our online store.</p><p>We hope to see you soon.</p><p> Thank you for your trust!</p>",
          es: "<p>Tu retroalimentación nos ayuda a mejorar para ofrecerte la mejor experiencia en nuestra tienda en línea.</p><p>Esperamos verte pronto.</p><p>Gracias por tu confianza!</p>"
        }
      },
      privacyPolicy: defaultPrivacyLinksTecnolite,
    },
    params: []
  },
  {
    id: 'tec-b2b-ec',
    label: 'B2B - Experiencia de compra',
    config: {
      surveyDef: Object.assign({ _id: 'tec-b2b-ec' }, B2BExperienciaCompra),
      data: defaultDataTecnolite,
      preferredLanguage: SupportedLanguages.es,
      complete: {
        title: {
          default: "We have received your opinion.",
          es: "Hemos recibido tu opinión."
        },
        message: {
          default: "<p>Your feedback helps us improve to offer you the best experience in our online store.</p><p>We hope to see you soon.</p><p> Thank you for your trust!</p>",
          es: "<p>Tu retroalimentación nos ayuda a mejorar para ofrecerte la mejor experiencia en nuestra tienda en línea.</p><p>Esperamos verte pronto.</p><p>Gracias por tu confianza!</p>"
        }
      },
      privacyPolicy: defaultPrivacyLinksTecnolite,
      extensions:{
        pages: [
          {
            type: "skippable",
            names: [
              "P6_TEC_EC_B2B",
              "P7_TEC_EC_B2B",
              "P8_TEC_EC_B2B"
            ],
            customButtonNames: {
              P6_TEC_EC_B2B: {
                skipName: {
                  es: "No aplica",
                  default: "Not apply"
                }
              },
              P7_TEC_EC_B2B: {
                skipName: {
                  es: "No aplica",
                  default: "Not apply"
                }
              },
              P8_TEC_EC_B2B: {
                skipName: {
                  es: "Ningún problema",
                  default: "No problem"
                }
              }
            },
            completeName: {
              es: "Enviar",
              default: "Send"
            },
            defaultCompleteName: {
              es: "Terminar",
              default: "Complete"
            }
          }
        ]
      },
    },
    params: []
  },
]

export const registeredSurveysViva: Array<RegisteredSurvey> = [
  {
    id: 'vvcx',
    label: 'Viva Aerobus',
    config: {
      surveyDef: Object.assign({ _id: 'vvcx' }, vvcxSurveyConfig),
      data: defaultDataViva,
      preferredLanguage: SupportedLanguages.default,
      complete: defaultComplete,
      privacyPolicy: defaultPrivacyLinksViva,
    },
    params: []
  },
  /*{
    id: 'vvcx-next',
    label: 'Viva Aerobus (Cambios pendientes)',
    config: {
      surveyDef: Object.assign({ _id: 'vvcx-next' }, vvcxNextSurveyConfig),
      data: defaultDataViva,
      preferredLanguage: SupportedLanguages.default,
      complete: defaultComplete,
      privacyPolicy: defaultPrivacyLinksViva,
    },
    params: []
  },*/
  {
    id: 'vvcx-v2',
    label: 'Viva Aerobus (Nuevos Cambios)',
    config: {
      surveyDef: Object.assign({ _id: 'vvcx-v2' }, vvcxV2SurveyConfig),
      data: defaultDataViva,
      preferredLanguage: SupportedLanguages.default,
      complete: {
        title: {
          default: "Thank you!",
          es: "¡Gracias!"
        },
        message: {
          default: "<p>We got your opinion.</p><p>All the team at <b>Viva Aerobus</b> will work to give you a better experience.</p><p>You are already participating in our monthly draw and you can win a round trip flight for two people to any Viva Aerobus destination</p>",
          es: "<p>Hemos recibido tu opinión.</p><p>Todo el equipo de <b>Viva Aerobus</b> trabajará para mejorar tu experiencia.</p><p>Ya estás participando en nuestro sorteo mensual y podrás ganar un vuelo redondo para dos personas a cualquier destino de Viva Aerobus</p>"
        }
      },
      privacyPolicy: defaultPrivacyLinksViva,
    },
    params: []
  },
]

export const registeredSurveysCx: Array<RegisteredSurvey> = [
  {
    id: 'acx',
    label: 'Aerolinea',
    config: {
      surveyDef: Object.assign({ _id: 'acx' }, cxAirline),
      data: defaultDataViva,
      preferredLanguage: SupportedLanguages.es,
      complete: defaultComplete,
      privacyPolicy: defaultPrivacyLinksCx,
    },
    params: []
  },
  {
    id: 'acx-v2',
    label: 'Aerolinea V2',
    config: {
      surveyDef: Object.assign({ _id: 'acx-v2' }, cxAirlinev2),
      data: defaultDataViva,
      preferredLanguage: SupportedLanguages.es,
      complete: defaultComplete,
      privacyPolicy: defaultPrivacyLinksCx,
    },
    params: []
  },
  {
    id: 'tcx',
    label: 'Tienda en linea',
    config: {
      surveyDef: Object.assign({ _id: 'tcx' }, cxShop),
      data: defaultDataTecnolite,
      preferredLanguage: SupportedLanguages.es,
      complete: defaultComplete,
      privacyPolicy: defaultPrivacyLinksCx,
      ruleCompleteMessage: "if (ctx.hasOwnProperty('SHOPPING_EXPERIENCE_NPS')){ return [0,1,2,3,4,5,6,7,8].includes(ctx['SHOPPING_EXPERIENCE_NPS']) ? {message: { es: '<p>Hemos recibido tu opinión.</p><p>Estamos trabajando para mejorar tu experiencia en nuestro sitio web.</p><p>¡Esperamos verte pronto en nuestra tienda en línea!</p>',default:'<p>We have received your opinion.</p><p>We are working to improve your experience on our website.</p><p>We hope to see you soon in our online store !</p>'}} : { message: { es: '<p>Hemos recibido tu opinión.</p><p>Estamos aquí para brindarte el mejor servicio.</p><p>¡Esperamos verte pronto en nuestra tienda en línea!</p>', default:'<p>We have received your opinion.</p><p>We are here to provide you with the best service.</p><p>We hope to see you soon in our online store!</ p>'}} }",
      extensions:{
        pages: [
          {
            type: "skippable",
            names: [
              "P5_TEC_EC"
            ],
            buttonName: {
              es: "Omitir",
              default: "Skip"
            },
            buttonNameLast: {
              es: "Omitir y terminar",
              default: "Skip and complete"
            },
            completeName: {
              es: "Enviar",
              default: "Send"
            },
            defaultCompleteName: {
              es: "Terminar",
              default: "Complete"
            }
          }
        ]
      }
    },
    params: []
  },
  {
    id: 'scx',
    label: 'Sanitarios',
    config: {
      surveyDef: Object.assign({ _id: 'scx' }, cxRestroom),
      data: defaultDataRestrooms,
      preferredLanguage: SupportedLanguages.es,
      complete: defaultComplete,
      privacyPolicy: defaultPrivacyLinksCx,
    },
    params: [
      {key: 'country', value: 'MX'},
      {key: 'building', value: 'Reforma26'},
      {key: 'level', value: '3'},
      {key: 'space_type', value: 'restroom'},
      {key: 'space', value: 'womens restroom'},
    ]
  },
  {
    id: 'ocx',
    label: 'Oficinas',
    config: {
      surveyDef: Object.assign({ _id: 'ocx' }, cxConference),
      data: {},
      preferredLanguage: SupportedLanguages.es,
      complete: defaultComplete,
      privacyPolicy: defaultPrivacyLinksCx,
    },
    params: []
  }
]